module.exports = __webpack_public_path__ + "img/odt-file-format.59a63ede.png";